import React from 'react';
import ReactDOM from 'react-dom';

import ShareDialog from '../myjsx/views/ShareDialog.jsx';

jQuery( document ).ready(function(){
    jQuery('.share-button').each(function(i) {
        // adding react element
        let newDialogId='react-share-button-' + i;
        console.log(`Handling ${newDialogId}`);
        jQuery('body').append(`<div id="${newDialogId}"></div>`);
        ReactDOM.render(
            <ShareDialog 
                buttonId={newDialogId}
                shareUrl={window.location.href}
                facebook={{}}
                twitter={{
                    title:'WE CAN TRANSFORM YOU / BETTER – STRONGER – HEALTHIER'
                }}
                email={{
                    subject:"WE CAN TRANSFORM YOU / BETTER – STRONGER – HEALTHIER",
                    body:"Have a look at the " + document.title + " page of the Operation Tone-Up website!\n\n" + window.location.href
                }}
            />,
            document.getElementById(newDialogId),
            () => {
                console.log('done');
                var modalId=`#modal-${newDialogId}`;
                jQuery(modalId).on('show.bs.modal', function (e) {
                    //window.panelcontentzindex = jQuery('#panel-content').css('z-index');
                    //window.panelrightzindex = jQuery('#panel-right').css('z-index');
                    
                    //jQuery('#panel-content').css('z-index', 'auto');
                    //jQuery('#panel-right').css('z-index', 'auto');
                    //jQuery("#panel-content").css("padding-right", "0px");
                });

                jQuery(modalId).on('hidden.bs.modal', function (e) {
                    // fix z-index of the panels
                      //jQuery('#panel-content').css('z-index', '2');
                      //jQuery('#panel-right').css('z-index', window.panelrightzindex);
                      //jQuery("#panel-content").css("padding-right", 'auto');
                });

                jQuery(this).click(function() {
                    console.log('opening modal ' + modalId);

                    jQuery(modalId).modal('show');
                })
            }
          );
    })
}) 